export enum CancelInvoiceAction {
  CreateCreditNote = 'creditNote',
  DeleteInvoice = 'deleteInvoice',
}
